import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import Link         from './Link'
import Thumbnail    from './Thumbnail'
import ProjectPanel from './ProjectPanel'
import ProjectType  from './ProjectType'

const ProjectsPanel = props =>
  <div className={`projects-panel ${props.projectPanel ?
    'projects-panel-selected' : ''}`}>

    <div className="projects-list list-group list-group-flush">
      {props.projects.map(project =>
        <Link
          key={project.slug}
          href={`#${project.slug}`}
          onClick={props.setProjectPanel}
          className="list-group-item list-group-item-action t-spacing p-sm-4 p-md-5 p-lg-4 p-xl-5"
        >
          <div className="media">
            <Thumbnail
              className="t-spacing mr-3 mr-sm-4 mr-lg-3 mr-xl-4 my-auto rounded-circle"
              width="100"
              src={project.images[0]}
              style={{ maxWidth: '20%' }}
            />

            <div className="media-body my-auto">
              <ProjectType project={project} />

              <div className="h4">{project.name}</div>

              <p className="lead text-black-50 mb-0">
                <FontAwesomeIcon icon="map-marker-alt" fixedWidth />
                {' '}
                <i>{project.location}</i>
              </p>
            </div>

            <FontAwesomeIcon
              icon="angle-right"
              size="2x"
              className="text-black-50 t-spacing ml-3 ml-sm-4 ml-lg-3 ml-xl-4 my-auto"
            />
          </div>
        </Link>
      )}
    </div>

    <div className="project-panels bg-white">
      {props.projects.map(project =>
        <ProjectPanel
          key={project.slug}
          project={project}
          current={props.projectPanel}
        />
      )}
    </div>
  </div>

export default ProjectsPanel
